const YTPlayer = require('yt-player');

export default {
  init($element) {

  },
  finalize($element) {
    const $videoWrap = $element.find('.video-wrap');
    const $video = $videoWrap.find('.video-holder');
    const $videoSplash = $videoWrap.find('.splash-trigger');
    
    if ($video.length > 0) {
      const ytId = $video.data('yt-id');
      const elId = $video.attr('id');
      
      const player = new YTPlayer(`#${elId}`);
      player.load(ytId);

      $videoSplash.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $videoSplash.hide();
        player.play();
      });

      player.on('ended', () => {
        $videoSplash.show();
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/fullWidthVideo.js